import API from '../Util/api';

const getSingleUserPreference = id => {
  return API.get(`/user/preferences/${id}`)
    .then(resp => {
      return resp.data;
    });
}

export const GetSingleUserPreference_String = id => {
  return getSingleUserPreference(id)
    .then(pref => {
      return pref.StringValue;
    })
}

export const GetSingleUserPreference_Bool = id => {
  return getSingleUserPreference(id)
    .then(pref => {
      return pref.BoolValue;
    });
}

export const GetSingleUserPreference_Object = id => {
  return getSingleUserPreference(id)
    .then(pref => {
      return pref.MapValue;
    })
}

const saveSingleUserPreference = (id, singleUserPreference) => {
  if (!singleUserPreference || !id) {
    return Promise.resolve();
  }

  return API.put(`/user/preferences/${id}`, singleUserPreference);
}

export const SaveSingleUserPreference_String = (ID, StringValue) => {
  return saveSingleUserPreference(ID, {StringValue});
}

export const SaveSingleUserPreference_Bool = (ID, BoolValue) => {
  return saveSingleUserPreference(ID, {BoolValue});
}

export const SaveSingleUserPreference_Object = (ID, MapValue) => {
  return saveSingleUserPreference(ID, {MapValue});
}